import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';

export function AreaAside(props: BoxProps) {
  const { className, ...rest } = props;
  const defaults = {
    sx: {
      paddingTop: 2,
      paddingRight: 2,
      '.embedded-layout__container &': {
        paddingRight: 0,
        paddingLeft: 2,
        paddingTop: 0,
      },
    },
    className,
  };

  return <Box {...{ ...defaults, ...rest }} />;
}
